import Vue from 'vue'
import $ from 'jquery'
import _ from 'underscore'
import rewardingTalentHandbook from './rewarding_talent_handbook'
import expandingIntoEuropeHandbook from './expanding_into_europe_handbook'
import scalingThroughChaos from './scaling_through_chaos.js'
import winningInTheUS from './winning_in_the_us.js'
import { ivShare } from './iv-share'
import attachSocialShareEvents from '../../../ui/js/utils/attachSocialShareEvents'

import Bugsnag from '@bugsnag/js'
import bugsnagConfig from '../../../ui/js/utils/bugsnagConfig.js'
import Cookies from 'js-cookie'

export default {
    init: function () {
        Bugsnag.start(bugsnagConfig)
        Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)

        let sharedState = {
            route: {
                previousUrl: '',
                url: '',
                title: '',
            },
            chapter: {
                id: '',
                defaultId: '',
                title: '',
            },
            section: {
                id: '',
                defaultId: '',
                title: '',
            },
            subsection: {
                id: '',
                defaultId: '',
                title: '',
            },
            search: {
                query: '',
                results: [],
                form: null,
                placeholderDefault: 'Search the book',
                placeholderEnabled: true,
                inProgress: false,
                inputTimeout: 0,
                totalResults: 0,
                request: null,
            },
            nav: {
                full: {
                    open: false,
                },
                side: {
                    open: false,
                },
                top: {
                    sectionId: '',
                    title: '',
                    displayNumber: '',
                },
                next: {
                    sectionId: '',
                    title: '',
                    displayNumber: '',
                },
                prev: {
                    sectionId: '',
                    title: '',
                    displayNumber: '',
                },
            },
            progress: {
                percent: 0.0,
            },
            popstate: {
                timeStamp: 0,
            },
            isMobile: false,
            isTablet: false,
            isDesktop: false,
            modal: {
                show: false,
                html: '',
            },
            downloadModal: {
                show: false,
            },
            config: {
                debug: false,
                mobile: {
                    breakpoint: 0,
                    expandedHeader: 74,
                    compactHeader: 74,

                    contentOffset: 20,
                },
                tablet: {
                    breakpoint: 768,
                    expandedHeader: 74,
                    compactHeader: 74,

                    contentOffset: 68,
                },
                desktop: {
                    breakpoint: 1024,
                    expandedHeader: 154,
                    compactHeader: 94,

                    contentOffset: 68,
                },
            },
            timer: {
                sidebarScroll: 0,
            },
            tooltip: {
                width: 300,
                show: false,
                title: 'title',
                body: 'body',
                posX: 0,
                posY: 0,
                offsetY: 10,
                marginX: 10,
                innerX: 0,
            },
            activeGlossary: 'A',
            highContrast: window.matchMedia('(prefers-contrast: more)').matches,
            activeChildElements: [],
        }

        if (window.location.href.includes('rewarding-talent')) {
            sharedState.handbook = rewardingTalentHandbook
        } else if (window.location.href.includes('winning-in-europe')) {
            sharedState.handbook = expandingIntoEuropeHandbook
        } else if (window.location.href.includes('scaling-through-chaos')) {
            sharedState.handbook = scalingThroughChaos
        } else if (window.location.href.includes('winning-in-the-us')) {
            sharedState.handbook = winningInTheUS
        }

        let handbook = new Vue({
            // This Vue element is defined in vue-job-search.tpl.php
            el: '#vue-handbook',
            // Child components for this app.
            components: {
                ivShare,
            },
            // Shared data state between the app and each facet.
            data: sharedState,

            created: function () {
                // We set history.scrollRestoration and use window.history to push
                // history changes to.
                if ('scrollRestoration' in window.history) {
                    window.history.scrollRestoration = 'manual'
                }
                let pathArray = this.getPathArray()

                this.$nextTick(function () {
                    // Set default section.
                    _(this.handbook.structure).forEach(function (chapter, key) {
                        if (handbook.section.id === '' && chapter.order === '0') {
                            handbook.chapter.defaultId = key
                            handbook.section.defaultId = chapter.sectionId
                            if (pathArray[2]) {
                                // If starting from a link to a section, use that section.
                                handbook.setSectionId(pathArray[2])
                            } else {
                                handbook.setSectionId(chapter.sectionId)
                            }
                        }
                    })

                    let $window = $(window)
                    let $body = $('body')
                    $window.on('scroll resize load', _.throttle(this.setProgressPercent, 300))
                    $body.on('scroll', _.throttle(this.setProgressPercent, 300))

                    $window.on('scroll resize', _.throttle(this.setSectionInView, 710))
                    $body.on('scroll ', _.throttle(this.setSectionInView, 710))

                    $window.on('popstate', _.throttle(this.setPopstateTimeStamp, 100))
                    $window.on('resize load', _.throttle(this.setBreakpoint, 100))
                    $window.on('popstate hashchange', this.loadFromUrl)
                    // Doc ready can be used if you don't use it on the whole init function but initial load can't scrollTo.
                    $window.on('load', function () {
                        handbook.loadFromUrl()
                        handbook.saveToUrl(false)
                    })

                    $window.on('scroll resize', _.throttle(this.resetGlossary, 100))
                    $body.on('scroll', _.throttle(this.resetGlossary, 100))

                    $(window).on('resize', _.throttle(this.tableMoreOnResize, 100))
                })
            },

            computed: {
                progressStyle: function () {
                    return 'width: ' + this.progress.percent + '%;'
                },

                progressPercentText: function () {
                    return this.progress.percent > 0 ? Math.round(this.progress.percent) + '%' : ''
                },

                progressTitle: function () {
                    let title = ''
                    let chapterId = this.chapter.id
                    if (this.handbook.structure.hasOwnProperty(chapterId)) {
                        title = this.handbook.structure[chapterId].title

                        if (this.isMobile && this.handbook.structure[chapterId].displayNumber) {
                            title = this.handbook.structure[chapterId].displayNumber + ' -  ' + title
                        }

                    }
                    return title
                },

                showChapterTop: function () {
                    return this.nav.top.title !== ''
                },

                showChapterNext: function () {
                    return this.nav.next.title !== ''
                },

                hasStory: function () {
                    return document.querySelector(`#${this.chapter.id} > .story-content`)
                },

                showChapterBlank: function () {
                    return this.showChapterNext && !this.isMobile
                },

                showChapterPrev: function () {
                    return this.nav.prev.title !== ''
                },

                showChapterButtonsBottom: function () {
                    return this.chapter.id !== 'chapter-0' && (this.showChapterTop || this.showChapterNext)
                },

                showFooter: function () {
                    // return this.chapter.id !== 'chapter-0'
                    return true
                },

                // Space between text section and header.
                contentOffset: function () {
                    if (this.isMobile) {
                        return this.config.mobile.contentOffset
                    }
                    if (this.isTablet) {
                        return this.config.tablet.contentOffset
                    }
                    if (this.isDesktop) {
                        return this.config.desktop.contentOffset
                    }
                },

                validQuery: function () {
                    return this.search.query.trim().length >= 1
                },

                searchTooltip: function () {
                    if (!this.validQuery) return ''
                    if (this.search.inProgress) return 'Searching...'
                    if (this.search.results.length === 0) return 'No results'
                    return `${this.search.totalResults} results`
                },
            },

            methods: {
                log: function (string, data = false) {
                    if (this.config.debug === true) {
                        if (data !== false) {
                            console.log(string, data)
                        } else {
                            console.log(string)
                        }
                    }
                },

                getPathArray: function () {
                    let pathname = window.location.pathname
                    return pathname.split('/')
                },

                loadFromUrl: function () {
                    this.log('loadFromUrl')

                    // /rewarding-talent/handbook/sectionId
                    let pathArray = this.getPathArray()
                    if (this.handbook.is_stc_style) {
                        let activePath = $(`#contents-${this.section.id}`)
                        if (activePath.length !== 0) {
                            this.initActiveChildrenOnLoad(activePath)
                        }
                    }

                    if (pathArray.length === 3) {
                        this.setSectionId(pathArray[2])
                    } else {
                        this.setSectionId(this.section.defaultId)
                    }
                    this.jumpToSection()
                },

                saveToUrl: function (push = true) {
                    this.log('saveToUrl')
                    // No longer using # fragments
                    let pathArray = this.getPathArray()
                    pathArray.pop()
                    // we don't want to change the starting url for analytics purposes
                    pathArray[2] = this.section.id === 'start-section' ? '' : this.section.id

                    let title = this.handbook.title
                    if (this.chapter.id !== 'chapter-0' && this.chapter.title !== '') {
                        title += ' | ' + this.chapter.title
                    }
                    if (this.section.title !== '') {
                        title += ' | ' + this.section.title
                    }
                    title += ' | Index Ventures'

                    // Unbind popstate to avoid infinite loops.
                    $(window).off('popstate', this.loadFromUrl)
                    if (push === true) {
                        window.history.pushState(null, title, pathArray.join('/'))
                    } else {
                        window.history.replaceState(null, title, pathArray.join('/'))
                    }
                    // Rebind loadFromUrl
                    $(window).on('popstate', this.loadFromUrl)

                    this.route.previousUrl = this.route.url
                    this.route.url = window.location.href
                    this.route.title = title
                    document.querySelector('link[rel="canonical"]').href = window.location.href

                    if (typeof window.gtag !== 'undefined') {
                        if (this.route.url !== this.route.previousUrl) {
                            let element = document.querySelector('[data-content-group-name]')
                            let ga4config = {}
                            if (element && element.dataset.contentGroupName) {
                                ga4config['content_group'] = element.dataset.contentGroupName
                            }
                            window.gtag('event', 'page_view', ga4config)
                        }
                    }

                    if (this.handbook.is_stc_style) {
                        if (!this.activeChildElements.includes(`contents-${this.section.id}`)) {
                            this.activeChildElements = []
                            let nextSectionElement = $(`#contents-${this.section.id}.is-group-title`)
                            if (nextSectionElement.length !== 0) {
                                this.initActiveChildren(nextSectionElement)
                            } else {
                                let activePath = $(`#contents-${this.section.id}`)
                                if (activePath.length !== 0) {
                                    this.initActiveChildrenOnLoad(activePath)
                                }
                            }
                        }
                    }
                },

                initActiveChildrenOnLoad: function (activePath) {
                    if (!activePath.hasClass('is-group-title')) {
                        let previousGroupPath = ''
                        while (!previousGroupPath) {
                            activePath = activePath.prev()
                            if (activePath.hasClass('is-group-title')) {
                                previousGroupPath = activePath
                                this.initActiveChildren(previousGroupPath)
                            }
                        }
                    }
                },

                initActiveChildren: function (selectedElement) {
                    let listElements = selectedElement.nextUntil('.is-group-title')
                    listElements.each(x => {
                        this.activeChildElements.push(listElements[x].id)
                    })
                },
                openModalWithContent: function (html) {
                    if (!handbook.isMobile) {
                        handbook.modal.html = html
                        handbook.resetGlossary()
                        handbook.initGlossary()
                        handbook.modal.show = true
                    }
                },

                // Initialize the zoom modal popups, note that doing this onLoad has some weird bug
                // where it works fine until you visit the frontpage then they are all wiped,
                // so I'm now running this each time we change chapter, and limiting to anything
                // not(.zoom-processed) so we never double up event listeners.
                initZoom: function () {
                    let zoomWrap = '<div class="zoom-wrapper"></div>'
                    // let zoomBefore = '<div class="zoom-icon"><i class="icon-line-expand-2"></i></div>'
                    let zoomBefore = '<div class="zoom-icon"><svg version="1.1" id="Outline_Version" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid slice" xml:space="preserve"><path d="M23.5,6C23.776,6,24,5.776,24,5.5v-5c0-0.065-0.013-0.13-0.039-0.191c-0.05-0.122-0.148-0.22-0.271-0.271 C23.63,0.014,23.565,0,23.5,0h-5C18.224,0,18,0.224,18,0.5S18.224,1,18.5,1h3.793L12,11.293L1.707,1H5.5C5.776,1,6,0.776,6,0.5 S5.776,0,5.5,0h-5C0.435,0,0.37,0.014,0.309,0.038c-0.123,0.051-0.22,0.148-0.271,0.271C0.013,0.37,0,0.435,0,0.5v5 C0,5.776,0.224,6,0.5,6S1,5.776,1,5.5V1.707L11.293,12L1,22.293V18.5C1,18.224,0.776,18,0.5,18S0,18.224,0,18.5v5 c0,0.065,0.013,0.13,0.039,0.191c0.05,0.122,0.148,0.22,0.271,0.271C0.37,23.986,0.435,24,0.5,24h5C5.776,24,6,23.776,6,23.5 S5.776,23,5.5,23H1.707L12,12.707L22.293,23H18.5c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h5c0.065,0,0.13-0.014,0.191-0.038 c0.123-0.051,0.22-0.148,0.271-0.271C23.987,23.63,24,23.565,24,23.5v-5c0-0.276-0.224-0.5-0.5-0.5S23,18.224,23,18.5v3.793 L12.707,12L23,1.707V5.5C23,5.776,23.224,6,23.5,6z"/> </svg></div>'
                    Vue.nextTick(() => {
                        let $handbookZoom = $('.handbook__zoom').not('.zoom-processed')
                        $handbookZoom.each(function () {
                            let $zoom = $(this)
                            $zoom.wrap(zoomWrap)
                            $zoom.before(zoomBefore)
                            let $copy = $('<div>').html($zoom.html())
                            // remove div wrapper
                            $copy.find('div').contents().unwrap()
                            // remove image styles added for reserving the image space and accurate scroll jumps
                            $copy.find('img').removeAttr('style')
                            $copy.prepend('<!-- Inline styles removed -->\n')
                            let html = $copy.html()
                            $zoom.parent().on('click', function () {
                                handbook.openModalWithContent(html)
                            })
                            $zoom.find('.zoom-icon').on('click', function () {
                                handbook.openModalWithContent(html)
                            })
                            $zoom.addClass('zoom-processed')
                        })
                    })
                },

                // Adds indicators that a table has more to scroll sideways to.
                initTableScroll: function () {
                    // NextTick so it happens after ZoomInit above...
                    Vue.nextTick(() => {
                        let $tableScrollWrappers = $('.table-scroll-wrapper:not(.table-can-scroll-processed)')

                        $tableScrollWrappers.each(function () {
                            let $tableScrollWrapper = $(this)
                            let $tableCanScroll = $('<div class="table-can-scroll"></div>')

                            if ($tableScrollWrapper.hasClass('breakout-left-right')) {
                                $tableCanScroll.addClass('breakout-left-right')
                                $tableScrollWrapper.removeClass('breakout-left-right')
                            }

                            $tableScrollWrapper.wrap($tableCanScroll).before('<div class="more-to-left"></div><div class="more-to-right"></div>').addClass('table-can-scroll-processed')

                            $tableScrollWrapper.on('scroll', handbook.tableMoreOnTableScroll)

                            handbook.tableMoreLeftRight($tableScrollWrapper)
                        })

                    })
                },

                tableMoreOnTableScroll: function (event) {
                    let $tableScrollWrapper = $(event.target)
                    this.tableMoreLeftRight($tableScrollWrapper)
                },

                tableMoreOnResize: function () {
                    let $tableScrollWrappers = $('.table-scroll-wrapper')

                    $tableScrollWrappers.each(function () {
                        let $tableScrollWrapper = $(this)
                        handbook.tableMoreLeftRight($tableScrollWrapper)
                    })
                },

                tableMoreLeftRight: function ($tableScrollWrapper) {
                    let moreSize = 30
                    let $table = $tableScrollWrapper.find('table').first()
                    let $moreToLeft = $tableScrollWrapper.parent().find('.more-to-left').first()
                    let $moreToRight = $tableScrollWrapper.parent().find('.more-to-right').first()

                    if ($table.width() > $tableScrollWrapper.width()) {
                        let left = $tableScrollWrapper.offset().left - $table.offset().left
                        let right = $table.width() - $tableScrollWrapper.width() - left

                        let leftPos = left <= moreSize ? -moreSize + left : 0
                        $moreToLeft.css('left', leftPos + 'px')

                        let rightPos = right <= moreSize ? -moreSize + right : 0
                        $moreToRight.css('right', rightPos + 'px')
                    } else {
                        // Reset
                        $moreToLeft.css('left', -moreSize + 'px')
                        $moreToRight.css('right', -moreSize + 'px')
                    }
                },

                closeModal: function () {
                    handbook.resetGlossary()
                    handbook.modal.show = false
                    handbook.modal.html = ''
                },

                openDownloadModal: function () {
                    handbook.downloadModal.show = true
                    Vue.nextTick(() => {
                        if (typeof hbspt === 'undefined') {
                            return
                        }
                        const modalElement = document.querySelector('.form-modal-content')
                        const pdfUrl = modalElement.dataset.pdfUrl
                        hbspt.forms.create({ //eslint-disable-line no-undef
                            portalId: '19565345',
                            formId: '2fdecaa0-3248-4983-8fb7-00099ca5b6e4',
                            region: 'na1',
                            target: '#hubspot-form-container',
                            onFormReady: function ($form) {
                                const iframeDoc = $form[0].ownerDocument

                                if (!iframeDoc.getElementById('custom-hs-input-style')) {
                                    const style = iframeDoc.createElement('style')
                                    style.id = 'custom-hs-input-style'

                                    style.textContent = `
                                        .hs-input:not([type=file]) {
                                            background-color: #F5F5F5;
                                            border-color: #E3E3E3;
                                        }
                                        .hs-input:not([type=file]):not(.invalid):not(.error):focus {
                                            border-color: #C0C0C0;
                                            outline: none;
                                        }
                                        .hs-form-field label:not(.hs-error-msg) {
                                            font-size: 16px !important;
                                            font-style: normal;
                                            line-height: 112%;
                                            letter-spacing: -0.16px;
                                        }
                                        div.hs-submit > div.actions > input.hs-button {
                                            color: #FFF;
                                            font-size: 12px;
                                            font-style: normal;
                                            font-weight: 500;
                                            letter-spacing: 0.72px;
                                            padding: 12px;
                                            height: 36px;
                                            border-radius: 4px;
                                            background-color: #000;
                                            display: inline-flex;
                                            justify-content: center;
                                            align-items: center;
                                        }
                                    `

                                    iframeDoc.head.appendChild(style)
                                }

                                const observer = new MutationObserver((mutations) => {
                                    for (const mutation of mutations) {
                                        if (mutation.type === 'childList') {
                                            $(mutation.target)
                                                .find('.hs-error-msg')
                                                .text('Required')
                                        }
                                    }
                                })

                                observer.observe($form[0], {
                                    childList: true,
                                    subtree: true,
                                })

                                const cleanupObserver = new MutationObserver((mutations) => {
                                    for (const mutation of mutations) {
                                        for (const node of mutation.removedNodes) {
                                            if (node === $form[0]) {
                                                observer.disconnect()
                                                cleanupObserver.disconnect()
                                            }
                                        }
                                    }
                                })

                                cleanupObserver.observe(iframeDoc.body, {
                                    childList: true,
                                    subtree: true,
                                })
                            },
                            onFormSubmitted: function () {
                                handbook.closeDownloadModal()
                                window.open(pdfUrl, '_blank')
                            },
                        })
                    })
                },

                closeDownloadModal: function () {
                    handbook.downloadModal.show = false
                },

                gotoChapterTop: function () {
                    this.gotoSection(this.nav.top.sectionId)
                },

                gotoChapterNext: function () {
                    this.gotoSection(this.nav.next.sectionId)
                },

                gotoChapterPrev: function () {
                    this.gotoSection(this.nav.prev.sectionId)
                },

                gotoSection: function (sectionId) {
                    this.log('gotoSection')
                    this.closeFullNav()
                    this.closeSideNav()
                    this.setSectionId(sectionId)
                    this.saveToUrl()
                    this.jumpToSection()
                },

                includeStories: function () {
                    const stories = this.handbook.is_stc_style && document.querySelector('.handbook-stories')
                    if (!stories) {
                        return
                    }
                    stories.innerHTML = ''
                    const story = document.querySelector(`#${this.chapter.id} > .story-content`)
                    if (story) {
                        stories.innerHTML = story.outerHTML
                    }
                },

                setSectionId: function (sectionId) {
                    this.log('setSectionId', sectionId)
                    this.section.id = sectionId
                    this.setChapterId()
                },

                setChapterId: function () {
                    this.log('setChapterId')
                    // Use handbook structure for chapter lookups
                    let sectionId = this.section.id
                    // Using arrow syntax so we still have access to this.
                    _(this.handbook.structure).forEach((chapter, key) => {
                        let chapterId = key
                        if (chapter.sectionId === sectionId) {
                            this.chapter.id = chapterId
                            this.chapter.title = chapter.title
                            this.section.title = ''
                            this.initZoom()
                            this.initTableScroll()
                            return
                        }
                        if (chapter.sections.length) {
                            _(chapter.sections).forEach((section) => {
                                if (section.id === sectionId) {
                                    this.chapter.id = chapterId
                                    this.chapter.title = chapter.title
                                    this.section.title = section.title
                                    this.initZoom()
                                    this.initTableScroll()
                                    return
                                }
                            })
                        }
                    })

                    this.setChapterNextPrev()
                    this.setSidebarScroll()
                    this.initGlossary()
                },

                setChapterNextPrev: function () {
                    this.log('setChapterNextPrev')
                    if (this.handbook.structure.hasOwnProperty(this.chapter.id)) {
                        // Reset the Next / Prev / Top
                        let top = {
                            sectionId: '',
                            title: '',
                            displayNumber: '',
                        }
                        let next = {
                            sectionId: '',
                            title: '',
                            displayNumber: '',
                        }
                        let prev = {
                            sectionId: '',
                            title: '',
                            displayNumber: '',
                        }

                        let chapterStructure = this.handbook.structure[this.chapter.id]
                        let order = parseInt(chapterStructure.order)

                        if (this.chapter.id !== 'chapter-0') {
                            top = {
                                sectionId: chapterStructure.sectionId,
                                title: chapterStructure.title,
                                displayNumber: chapterStructure.displayNumber,
                            }
                        }

                        _(this.handbook.structure).forEach((chapter) => {
                            // Find the previous chapter
                            if (this.chapter.id !== 'chapter-0') {
                                if (parseInt(chapter.order) === parseInt(order - 1)) {
                                    prev = {
                                        sectionId: chapter.sectionId,
                                        title: chapter.title,
                                        displayNumber: chapter.displayNumber,
                                    }
                                }
                            }
                            // Find the next chapter
                            if (parseInt(chapter.order) === parseInt(order + 1)) {
                                next = {
                                    sectionId: chapter.sectionId,
                                    title: chapter.title,
                                    displayNumber: chapter.displayNumber,
                                }
                            }
                        })

                        this.nav.top = top
                        this.nav.next = next
                        this.nav.prev = prev
                    }
                },

                setSidebarScroll: function () {
                    if (!this.isMobile) {
                        clearTimeout(this.timer.sidebarScroll)
                        this.timer.sidebarScroll = setTimeout(function () {
                            let $sidebar = $('.handbook__toc-sidebar')
                            let $activeChapter = $('.handbook__toc-sidebar > ul > li.active')
                            let $activeSection = $activeChapter.find('ul li.active')
                            if ($activeSection.length === 0) {
                                $activeSection = $activeChapter
                            }

                            if ($sidebar.length && $activeChapter.length) {
                                let sidebarTop = $sidebar.offset().top
                                let sidebarScrollTop = $sidebar.scrollTop()
                                let sidebarHeight = $sidebar.outerHeight()
                                let sectionMenuTop = $activeSection.offset().top - sidebarTop + sidebarScrollTop

                                // Scroll the section to the middle of the sidebar.
                                $sidebar.animate({
                                    scrollTop: sectionMenuTop - (.3 * sidebarHeight),
                                }, 100)
                            }
                        }, 600) // this must be at least 2 css animations, which default to 300ms each
                    }
                },

                chapterIsActive: function (chapterId, isDefault = false) {
                    return (chapterId === this.chapter.id) || (isDefault === true && this.chapter.id === '')
                },

                sectionIsActive: function (sectionId) {
                    return sectionId === this.section.id
                },

                isGroupTitle: function (isGroupTitle) {
                    return isGroupTitle
                },

                openSidebarChapter: function (chapterId) {
                    this.log('openSidebarChapter')
                    if (this.chapter.id === chapterId) {
                        this.gotoSection(chapterId)
                    }
                    this.chapter.id = chapterId
                },

                toggleFullNav: function () {
                    this.closeSearch()

                    // If we are opening the full nav.
                    if (this.nav.full.open === false) {
                        let $overlay = $('.handbook__toc-fullscreen')
                        let $activeChapter = $('.handbook__toc-fullscreen > ul > li.active')
                        let $activeSection = $activeChapter.find('ul li.active')
                        if ($activeSection.length === 0) {
                            $activeSection = $activeChapter
                        }

                        let overlayTop = $overlay.offset().top
                        let overlayScrollTop = $overlay.scrollTop()
                        let overlayHeight = $overlay.outerHeight()
                        let sectionMenuTop = $activeSection.offset().top - overlayTop + overlayScrollTop

                        $overlay.scrollTop(sectionMenuTop - (.3 * overlayHeight))
                    }

                    this.nav.full.open = !this.nav.full.open
                    if (this.nav.full.open) {
                        this.$nextTick(() => {
                            this.$refs['full-search-input'].focus()
                        })
                    }
                },

                toggleSideNav: function () {
                    this.closeSearch()
                    this.nav.side.open = !this.nav.side.open
                    if (this.nav.side.open) {
                        this.$nextTick(() => {
                            this.$refs['side-search-input'].focus()
                        })
                    }
                },

                closeFullNav: function () {
                    this.closeSearch()
                    this.nav.full.open = false
                },

                closeSideNav: function () {
                    this.closeSearch()
                    this.nav.side.open = false
                },

                onSearchInput: function () {
                    if (this.validQuery) {
                        this.search.inProgress = true
                        window.clearTimeout(this.searchInputTimeout)
                        this.searchInputTimeout = window.setTimeout(() => {
                            if (this.search.request) this.search.request.abort()
                            this.search.request = null
                            this.search.results = []
                            this.tocDisplay()
                            this.doSearch()
                        }, 250)
                    }
                    if (this.search.results.length && !this.validQuery) {
                        this.closeSearch()
                    }
                },

                onSearchClick: function () {
                    if (this.nav.full.open === false) {
                        this.toggleFullNav()
                    } else if (this.validQuery) {
                        this.doSearch()
                    }
                },

                doSearch: function () {
                    const query = this.search.query.trim()
                    this.search.inProgress = true
                    const handbookId = this.handbook.base_path.replace('/','')
                    const payload = {query, handbookId}
                    return new Promise(() => {
                        this.search.request = new XMLHttpRequest()
                        this.search.request.open('post', '/handbook_search')
                        this.search.request.onload = () => {
                            if (this.search.request.status >= 200 && this.search.request.status < 300) {
                                const response = JSON.parse(this.search.request.response)
                                this.search.totalResults = response.hits.total.value > 10 ? '10+' : response.hits.total.value
                                this.search.results = response.hits.hits.map(hit => ({
                                    sectionId: hit._source.section_id_filter,
                                    chapterTitle: hit._source.chapter_title,
                                    sectionTitle: hit._source.section_title || hit._source.subsection_title,
                                    subsectionTitle: hit._source.section_title ? hit._source.subsection_title : null,
                                    highlight: hit.highlight ? hit.highlight.handbook_content.slice(0, 3).map(item => `<p>...${item.trim()}...</p>`).join('') : '',
                                }))
                                this.tocDisplay()
                                this.search.inProgress = false
                            } else {
                                Bugsnag.notify(new Error(`Search request failed with status ${this.search.request.status}: ${this.search.request.statusText}`), event => {
                                    event.addMetadata('Search Request', {
                                        url: this.search.request.responseURL,
                                        status: this.search.request.status,
                                        responseText: this.search.request.responseText,
                                    })
                                })
                            }
                        }
                        this.search.request.onerror = () => {
                            this.search.inProgress = false
                            this.closeSearch()
                        }
                        this.search.request.setRequestHeader('X-CSRFToken', Cookies.get('csrf_token'))
                        this.search.request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
                        this.search.request.send(JSON.stringify(payload))
                    })
                },

                tocDisplay: function () {
                    if (this.search.results.length > 0) {
                        $('.handbook__toc-fullscreen').hide()
                        $('.handbook__toc-sidebar-list').hide()
                    } else {
                        $('.handbook__toc-fullscreen').show()
                        $('.handbook__toc-sidebar-list').show()
                    }
                },

                closeSearch: function () {
                    this.search.results = []
                    this.search.query = ''
                    this.tocDisplay()
                },

                setProgressPercent: function () {
                    let docHeight = $('.handbook__content').height()
                    let windowHeight = $(window).height()
                    let percent = parseFloat(Math.round($(window).scrollTop() / (docHeight - windowHeight) * 1000) / 10)
                    if (percent > 99) {
                        percent = 100.0
                    }
                    if (percent < 0 || isNaN(percent)) {
                        percent = 0.0
                    }
                    this.progress.percent = percent
                },

                setSectionInView: function (event) {
                    // Automatically changing the section has some bad effects, so we disable it after user navigation,
                    // and whilst the mobile menu is open.
                    if (event.timeStamp > this.popstate.timeStamp + 500 && (!this.isMobile || !this.nav.side.open)) {
                        let $sections = $('#' + this.chapter.id + ' [id]')
                        let sectionOnScreen = ''
                        if ($sections.length > 0) {
                            $sections.each(function () {
                                if (sectionOnScreen === '') {
                                    let $element = $(this)
                                    let elementTop = $element.offset().top
                                    let elementBottom = elementTop + $element.outerHeight()
                                    let offsetValue = 65
                                    let viewportTop = $(window).scrollTop() + offsetValue
                                    let viewportBottom = viewportTop + $(window).height() - offsetValue

                                    let isOnScreen = elementBottom > viewportTop && elementTop < viewportBottom

                                    if (isOnScreen) {
                                        sectionOnScreen = $element.prop('id')
                                    }
                                }
                            })
                            if (sectionOnScreen !== '' && sectionOnScreen !== handbook.section.id) {
                                // Set the current section to the one on screen.
                                handbook.setSectionId(sectionOnScreen)
                                this.saveToUrl()
                            }
                        }
                    }
                },

                setPopstateTimeStamp: function (event) {
                    if (event.hasOwnProperty('originalEvent')) {
                        this.popstate.timeStamp = event.timeStamp
                    }
                },

                preventScrollHeaderOpening: function () {
                    let nav = document.querySelectorAll('.js-navigation')
                    if (nav.length) {
                        nav[0].classList.add('-prevent-fixed-active')
                        document.removeEventListener('scrollend', this.reEnableNav)
                        document.addEventListener('scrollend', this.reEnableNav, {once: true})
                    }
                },

                reEnableNav: function() {
                    let nav = document.querySelectorAll('.js-navigation')
                    nav[0].classList.remove('-active')
                    nav[0].classList.remove('-prevent-fixed-active')
                    document.body.classList.remove('-header-compact')
                },

                jumpToSection: function () {
                    // Need to wait a tick for chapter to become active.
                    Vue.nextTick(() => {
                        // if section id is empty it means we are at the start-section
                        let $section = $('#' + (handbook.section.id ? handbook.section.id : 'start-section'))
                        if ($section.length) {
                            const headerHeight = 64
                            let scrollTo = $section.offset().top - headerHeight
                            if ($section.hasClass('handbook__chapter-header') || $section[0].id === 'start-section') {
                                scrollTo = 0
                            } else if (!$section.hasClass('handbook__section-company')) {
                                scrollTo -= this.contentOffset
                            }

                            handbook.log('$section', $section)
                            handbook.log('scrollTo --', scrollTo)
                            handbook.preventScrollHeaderOpening()
                            window.scrollTo(0, scrollTo)
                            // IE doesn't seem to update scroll after jump:
                            handbook.setProgressPercent()
                        } else {
                            handbook.log('Section not found')
                        }
                        this.includeStories()
                    })
                },

                setBreakpoint: function () {
                    this.log('setBreakpoint')
                    let windowWidth = $(window).width()
                    this.isMobile = windowWidth >= this.config.mobile.breakpoint && windowWidth < this.config.tablet.breakpoint
                    this.isTablet = windowWidth >= this.config.tablet.breakpoint && windowWidth < this.config.desktop.breakpoint
                    this.isDesktop = windowWidth >= this.config.desktop.breakpoint
                },

                initGlossary: function () {
                    Vue.nextTick(() => {
                        attachSocialShareEvents()
                        $('span[data-glossary]:not("handbook__tooltip-link")').on('click', function (event) {
                            handbook.resetGlossary()
                            let term = $(this).data('glossary')
                            if (typeof term !== 'undefined' && term !== '') {
                                handbook.tooltip.title = handbook.handbook.glossary[term].title
                                handbook.tooltip.body = handbook.handbook.glossary[term].body

                                // Position calc is off
                                let $link = $(event.currentTarget)
                                let $parent = $(handbook.$refs['vue-handbook'])
                                handbook.tooltip.posX = ($link.offset().left + ($link.width() / 2)) - (handbook.tooltip.width / 2) - $parent.offset().left
                                handbook.tooltip.posY = $link.offset().top + $link.height() + handbook.tooltip.offsetY /*- tooltipHeight*/ - $parent.offset().top

                                // Adjust the x position of the actual text so that it can't be off the screen.
                                let innerX = 0
                                let maxInnerX = (handbook.tooltip.width / 2) - 15
                                let minInnerX = -(handbook.tooltip.width / 2) + 15

                                // Don't go off the left side of screen.
                                if (handbook.tooltip.posX + $parent.offset().left < handbook.tooltip.marginX) {
                                    innerX = handbook.tooltip.marginX - handbook.tooltip.posX
                                }

                                // Don't go off the right side of screen.
                                if (handbook.tooltip.posX + $parent.offset().left + handbook.tooltip.width > $('body').width() - handbook.tooltip.marginX) {
                                    innerX = ($('body').width() - handbook.tooltip.marginX) - (handbook.tooltip.posX + handbook.tooltip.width)
                                }

                                // Don't let innerX go beyond the little pointer and break the tooltip layout.
                                innerX = innerX < maxInnerX ? innerX : maxInnerX
                                innerX = innerX > minInnerX ? innerX : minInnerX
                                handbook.tooltip.innerX = innerX

                                handbook.tooltip.show = true
                            }
                            event.stopPropagation()
                            event.preventDefault()
                        })
                        $('span[data-glossary]').addClass('handbook__tooltip-link')
                    })
                },

                resetGlossary: function () {
                    handbook.tooltip.show = false
                    handbook.tooltip.posX = 0
                    handbook.tooltip.posY = 0
                    handbook.tooltip.title = ''
                    handbook.tooltip.body = ''
                    handbook.tooltip.innerX = 0
                },

                setActiveGlossary: function (letter) {
                    this.activeGlossary = letter
                },

                getActiveGlossary: function () {
                    return this.activeGlossary
                },

                isActiveGlossary: function (letter) {
                    return letter === this.activeGlossary ? true : false
                },

                isHighContrast: function () {
                    return this.highContrast
                },

                isActiveChild: function (id) {
                    if (this.activeChildElements.includes(id)) {
                        return true
                    }
                    return false
                },

                toggleContrast: function () {
                    this.highContrast = !this.highContrast
                },
            },
        })
    },
}

if (document.querySelector('.split-glossary')) {
    let letterArr = []
    document.querySelectorAll('.split-glossary table tbody tr').forEach(x => {
        if (!letterArr.includes(x.getAttribute(':class').split("'")[1])) {
            letterArr.push(x.getAttribute(':class').split("'")[1])
        }
    })
    for (let i = 0; i < 26; i++) {
        if (!letterArr.includes(String.fromCharCode(65 + i))) {
            document.querySelectorAll('.glossary-menu a').forEach(x => {
                if (x.textContent === String.fromCharCode(65 + i)) {
                    x.classList.add('disabled')
                    x.removeAttribute('onclick')
                }
            })
        }
    }
}